import { createTheme } from '@mui/material/styles';

import { primaryTheme } from '../../../utils/theme';
import { FORTA_BLUE, FORTA_WHITE } from '../../../utils/colors';
import SortImg from '../../../assets/images/sort.svg';

export const timesheetTableTheme = createTheme({
  ...primaryTheme,
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: FORTA_BLUE.light3,
          boxShadow: 'none',
        },
        elevation2: {
          borderRadius: '10px',
          boxShadow: `0px 5px 5px ${FORTA_BLUE.light2}`,
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          cursor: 'default',
          borderCollapse: 'separate',
          borderSpacing: '0 20px',
          '& caption': {
            display: 'none',
          },
          textAlign: 'left',
        },
      },
    },
    MUIDataTableFilter: {
      styleOverrides: {
        root: {},
        MuiGrid: {
          root: {
            flexDirection: 'column',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          color: FORTA_BLUE.light1,
          backgroundColor: FORTA_WHITE,
          border: `2px solid ${FORTA_BLUE.light3}`,
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          padding: '0 !important',
          textAlign: 'left',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h6: {
          fontSize: '21px !important',
          fontWeight: '700 !important',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
        head: {
          borderRadius: 0,
          boxShadow: '0px 0px 0px rgba(0, 0, 0, 0.25)',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '12px',
          textAlign: 'left',
          backgroundColor: FORTA_WHITE,
          borderWidth: 0,
          fontSize: '16px',
          '&:first-of-type': {
            borderLeftStyle: 'solid',
            borderTopLeftRadius: 10,
            borderBottomLeftRadius: 10,
          },
          '&:last-of-type': {
            borderRightStyle: 'solid',
            borderTopRightRadius: 10,
            borderBottomRightRadius: 10,
          },
        },
      },
    },
    MUIDataTableHeadCell: {
      styleOverrides: {
        root: {
          backgroundColor: FORTA_BLUE.light3,
          padding: '0 8px',
          fontWeight: 'bold',
        },
        contentWrapper: {
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          '::before': {
            content: `""`,
            backgroundImage: `url(${SortImg})`,
            backgroundRepeat: 'no-repeat',
            width: '1.2em',
            height: '1.2em',
            display: 'block',
            marginTop: '0.5em',
            marginRight: '4px',
          },
        },
        sortAction: {
          '& path': {
            color: FORTA_BLUE.primary,
          },
        },
      },
    },
    MUIDataTableBodyCell: {
      styleOverrides: {
        root: {},
      },
    },
  },
});
